import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  Paper,
  Popover,
  MenuItem,
  IconButton,
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import Scrollbar from "src/components/Scrollbar";
import { CURRENT_USER } from "src/utils/constants";
import { UserListHead } from "src/sections/@dashboard/user";
import OrderContext from "src/context/Order/Order.Context.Provider";
import OrderListToolbar from "src/sections/@dashboard/order/OrderListToolbar";
import { toast } from "react-toastify";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { deleteOrder } from "src/service/order.service";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  return stabilizedThis?.map((el) => el[0]);
}
const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

function GradientCircularProgress() {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#74BAB6" />
            <stop offset="100%" stopColor="#EFA8B0" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress
        sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
      />
    </React.Fragment>
  );
}

export default function Order() {
  const loginData =
    JSON.parse(localStorage.getItem(CURRENT_USER)) ||
    JSON.parse(sessionStorage.getItem(CURRENT_USER));

  const TABLE_HEAD = [
    { id: "shootNo", label: "Shoot No.", alignRight: false },
    { id: "clientName", label: "Client Name.", alignRight: false },
    { id: "hospitalName", label: "Hospital Name.", alignRight: false },
    { id: "deliveryDate", label: "Soft Copy Delivery Date", alignRight: false },
    { id: "softCopies", label: "Soft Copy No.", alignRight: false },
    { id: "status", label: "Status", alignRight: false },
    ...(loginData?.role === "ADMIN"
      ? [{ id: "delete", label: "Delete", alignRight: false }]
      : []),
  ];
  const {
    orderData,
    setOrderData,
    fetchData,
    pagination,
    rowsPerPage,
    fetchedPages,
    page,
    setPage,
    setFetchedPages,
    search,
    setSearch,
    isLoading,
    status,
    hospital,
    deliveryDate,
    softCopyDeliveryDate,
  } = useContext(OrderContext);
  const [open, setOpen] = useState(null);

  const [order, setOrder] = useState("asc");

  const [orderBy, setOrderBy] = useState("name");

  const [dialogOpen, setDialogOpen] = useState(false);

  const [selectedOrderId, setSelectedOrderId] = useState("");

  const [enable, setEnable] = useState();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleDialogOpen = (row) => {
    setIsDialogOpen(true);
    setSelectedOrderId(row._id);
    console.log("testing dialog open new user");
  };

  const handleDelete = async (id) => {
    const { data } = await deleteOrder(id);
    if (data?.code === 200) {
      toast.success("Order Deleted Successfully");
      fetchData("", 0, "");
      setPage(0);
      setFetchedPages(1);
      console.log("Deleting shoot with ID:", id);
      handleDialogClose();
    } else {
      toast.error("There is an error in order deletion");
    }
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const navigate = useNavigate();

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    console.log(newPage, "newPage");
    setPage(newPage);
    if (newPage > fetchedPages - 1) {
      setFetchedPages((value) => value + 1);
    }
    console.log(fetchedPages, "fetchedPages");
  };

  const handleSearch = (event) => {
    setPage(0);
    setFetchedPages(1);
    setSearch(event.target.value);
  };

  const handleClickRow = (row) => {
    console.log(row?._id);
    navigate(`/orders/${row?._id}`);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - orderData?.length) : 0;

  const filteredUsers = applySortFilter(
    orderData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    getComparator(order, orderBy)
  );

  const isNotFound = !filteredUsers?.length && !!search;

  useEffect(() => {
    let timer;
    console.count("test Shoot List useEffect");

    const fetchDataWithDebounce = () => {
      fetchData(
        search,
        page * rowsPerPage,
        status,
        hospital,
        deliveryDate,
        softCopyDeliveryDate
      );
    };

    const debounce = () => {
      timer = setTimeout(fetchDataWithDebounce, 800);
    };

    const noDebounce = () => {
      if (fetchedPages === 1 || page >= fetchedPages - 1) {
        fetchDataWithDebounce();
      }
    };

    if (search) debounce();
    else noDebounce();

    return () => {
      clearTimeout(timer);
    };
  }, [
    search,
    fetchedPages,
    status,
    hospital,
    deliveryDate,
    softCopyDeliveryDate,
  ]);
  return (
    <>
      <Helmet>
        <title> Order | Camories </title>
      </Helmet>
      <Container maxWidth={false}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={3}
        >
          <Typography variant="h4" gutterBottom color="primary">
            {/* User */}
          </Typography>
          {/* {loginData?.role === 'ADMIN' && <Button variant="contained" style={{ backgroundColor: '#74BAB6', color: 'white' }}  startIcon={<ConfirmationNumberIcon />} onClick={handleDialogOpen}>
        Create Ticket
      </Button>}
        <TicketCreateDialogContent
          dialogOpen={dialogOpen}
          handleDialogClose={handleDialogClose}
          setHospitalData={setTicketData}
          fetchData={fetchData}
        /> */}
        </Stack>

        <Card>
          <OrderListToolbar
            search={search}
            onSearch={handleSearch}
            fetchData={fetchData}
          />

          <Scrollbar>
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "300px",
                }}
              >
                <GradientCircularProgress />
              </Box>
            ) : orderData?.length > 0 || isNotFound ? (
              <TableContainer sx={{ minWidth: 800, overflow: "hidden" }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    onRequestSort={handleRequestSort}
                  />

                  <TableBody>
                    {filteredUsers?.map((row) => {
                      // const { _id,frameDeliveryDate
                      //     , status } = row;
                      console.log(filteredUsers, "bal");
                      const deliveryDate =
                        new Date(row?.softCopyDeliveryDate) || "";
                      const options = {
                        timeZone: "Asia/Kolkata",
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      };

                      return (
                        <TableRow
                          hover
                          key={row?._id}
                          tabIndex={-1}
                          role="checkbox"
                        >
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ cursor: "pointer" }}
                              onClick={() => {
                                handleClickRow(row);
                              }}
                            >
                              {row?.shoot?.shootNo || "NA"}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={2}
                            >
                              <Typography
                                variant="subtitle2"
                                noWrap
                                sx={{ cursor: "pointer" }}
                                // onClick={() => {
                                //   handleClickRow(row);
                                // }}
                              >
                                {row?.shoot?.client?.name || "NA"}
                              </Typography>
                            </Stack>
                          </TableCell>

                          <TableCell align="left">
                            {row?.shoot?.hospital?.name}
                          </TableCell>
                          <TableCell align="left">
                            {deliveryDate.toLocaleString("en-US", options)}
                          </TableCell>
                          <TableCell align="left">
                            {row?.noOfSoftCopies || "Not Specified"}
                          </TableCell>

                          <TableCell align="left">
                            {row?.status || "Not Specified"}
                          </TableCell>
                          {loginData?.role === "ADMIN" ? (
                            <TableCell align="left">
                              <IconButton
                                size="large"
                                color="inherit"
                                onClick={(event) => handleDialogOpen(row)}
                              >
                                <DeleteOutlineIcon />
                              </IconButton>
                            </TableCell>
                          ) : null}
                          {/* <TableCell align="center">
                            <IconButton size="large" color="inherit" onClick={(event) => handleOpenMenu(event, row)}>
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow sx={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{search}&quot;</strong>.
                              <br /> Try checking for typos or using complete
                              words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="h4">Data not available.</Typography>
              </Box>
            )}
          </Scrollbar>
          {!isLoading && filteredUsers?.length > 0 && (
            <TablePagination
              rowsPerPageOptions={[rowsPerPage]}
              component="div"
              count={pagination?.total || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              // onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Card>
      </Container>

      {/* <Popover
      open={Boolean(open)}
      anchorEl={open}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MenuItem onClick={() => handleEdit(selectedHospitalId)}>Edit</MenuItem>

      <MenuItem sx={{ color: 'error.main' }}>
        <>
          <Grid
            item
            xs={10}
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: 'black',
            }}
            onClick={() => handleEnable(selectedHospitalId)}
          >
            {enable ? 'Disable' : 'Enable'}
          </Grid>
        </>
      </MenuItem>
      <MenuItem sx={{ color: 'error.main' }} onClick={handleOpenDialogDelete}>
        Delete
      </MenuItem>
    </Popover> */}
      <Dialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        TransitionComponent={Transition}
      >
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this Order?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDialogClose}
            variant="outlined"
            style={{
              backgroundColor: "white",
              color: "#EFA8B0",
              borderColor: "#EFA8B0",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            style={{
              backgroundColor: "white",
              color: "#74BAB6",
              borderColor: "#74BAB6",
            }}
            onClick={() => handleDelete(selectedOrderId)}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
